// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"EditorEmbed_embedContainer__HVHUO","embedComponent":"EditorEmbed_embedComponent___O4Bh","iframeContainer":"EditorEmbed_iframeContainer__qdTYy"};